export const FILE_SIZE_LABEL = 'Max size per file: 5MB';
export const FILE_SIZE_LIMIT = 6 * 1024 * 1024;